import SvgOptions from "../../Components/Svg/SvgOptions";
import User from "../../Services/User";
import Dashboard from "./Dashboard/Dashboard";
import Tasks from "./Tasks/Tasks";
import Notifications from "./Notifications/Notifications";


const btns = [
	{
		id: 1,
		text: "",
		icon: SvgOptions.Settings,
		className: "Inverse",
		onClick: () => {
			alert("btnAdd Clicked");
		},
	},
	{
		id: 2,
		text: "Add Task",
		icon: SvgOptions.Add,
		onClick: () => {
			alert("btnAdd Clicked");
		},
	},
	{
		id: 3,
		text: "Add Engineer",
		icon: SvgOptions.Add,
		onClick: () => {
			alert("btnAdd Clicked");
		},
	},
	{
		id: 4,
		text: "View Report",
		icon: SvgOptions.Receipt,
		onClick: () => {
			alert("btnAdd Clicked");
		},
	},
];

const pageControls = new Map([
	[
		"admin",
		new Map([
			["task", [btns[1], btns[0], btns[3]]],
			["engineer", [btns[2], btns[0]]],
		]),
	],
	[
		"enterprise-admin",
		new Map([
			["task", [btns[1], btns[0], btns[3]]],
			["engineer", [btns[2], btns[0]]],
		]),
	],
	[
		"operation",
		new Map([
			["task", [btns[1], btns[0]]],
			["engineer", [btns[2]]],
		]),
	],
	[
		"enterprise-ops",
		new Map([
			["task", [btns[1], btns[0]]],
			["engineer", [btns[2]]],
		]),
	],
	[
		"engineer",
		new Map([
			["task", []],
			["engineer", []],
		]),
	],
]);

const getControls = (page) => {
	const app_role = User.getRole();
	if (!app_role) return;
	if (pageControls.has(app_role.name)) {
		const app_ctrls = pageControls.get(app_role.name);
		return app_ctrls.get(page);
	}
};

const clientNavOptions = [
	{
		element: Dashboard,
		path: "Dashboard",
		access: ["client"],
		Protected: false,
		default: true,
		category: "maritime",
		icon: SvgOptions.Dashboard,
	},
	{
		element: Tasks,
		path: "Tasks/*",
		access: ["client"],
		Protected: false,
		default: false,
		category: "maritime",
		icon: SvgOptions.Task,
		controls: () => getControls("task"),
	},
];

const accNavOptions = [
	{
		element: Notifications,
		path: "Notifications/*",
		access: [
			"client",
		],
		Protected: false,
		default: true,
		notify: null,
		icon: SvgOptions.Bell,
	},
];

const logoutNav = {
	element: Notifications,
	path: "Logout",
	access: [
		"client",
	],
	Protected: false,
	default: true,
	title: User.getCompany()?.name,
	subTitle: "Log out",
	navImg: "",
	confirm: {},
};

export { accNavOptions, logoutNav };
export default clientNavOptions;
